<template>
  <div class="widget_wizard">
    <div
      class="tab-item"
      v-for="(item, index) in tabs"
      :key="index"
      :class="{ active: index + 1 == active }"
    >
      <div class="tab-title" @click="onClick(item, index)">
        {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "widget_wizard",
  props: {
    value: {
      type: Number,
      default: 1,
    },
    tabs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      active: 1,
    };
  },
  watch: {
    value(val) {
      let vm = this;
      vm.active = val;
    },
  },
  mounted() {
    let vm = this;
    vm.active = vm.value;
  },
  methods: {
    onClick(tab, index) {
      let vm = this;
      vm.active = index + 1;
      vm.$emit("change", tab);
      vm.$emit("input", vm.active);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/scss/constant_valiable.scss";
.widget_wizard {
  width: 100%;
  display: flex;
  align-items: center;
  .tab-item {
    display: flex;
    align-items: center;
    position: relative;
    margin-right: 20px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
    .tab-title {
      padding: 10px 10px;
    }
    &.active {
      .tab-title {
        border-bottom: 3px solid $color_primary;
        color: $color_primary;
      }
    }
  }
}
</style>
